import { useEffect, useRef } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const RELOAD_KEY = "bs-reload-build";

// Polls /api/version; when the build id changes it clears Cache Storage and
// reloads exactly once (localStorage guard prevents reload loops).
export const VersionWatcher = () => {
  const currentBuild = useRef(null);

  useEffect(() => {
    let timer;

    const check = async () => {
      try {
        const res = await fetch(`${BACKEND}/api/version`, { cache: "no-store" });
        if (!res.ok) return;
        const { build } = await res.json();
        if (!build) return;

        if (currentBuild.current === null) {
          currentBuild.current = build;
          // if we just reloaded for this build, clear the guard
          if (localStorage.getItem(RELOAD_KEY) === build) {
            localStorage.removeItem(RELOAD_KEY);
          }
          return;
        }

        if (build !== currentBuild.current) {
          if (localStorage.getItem(RELOAD_KEY) === build) return; // already reloaded
          localStorage.setItem(RELOAD_KEY, build);
          if (window.caches) {
            const keys = await caches.keys();
            await Promise.all(keys.map((k) => caches.delete(k)));
          }
          window.location.reload();
        }
      } catch {
        /* offline / transient — ignore */
      }
    };

    check();
    timer = setInterval(check, 10 * 60 * 1000);
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return null;
};
